//应用配置
module.exports = {
    appTitle:"云知-数字资源平台",
    apiPath: "/api",
  };
  